import React from "react";
import Home from "./Components/Home";
import SingleMovie from "./Components/SingleMovie";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";

import { Switch ,Route, Redirect} from "react-router-dom";

import './index.css';
import Movies from "./Components/Movies";
import './App.css';



const App=()=> {
  return (
   <>

   <Switch>
    <Route exact path="/" component={Home}/>
    <Route exact path="/movie/:id" component={SingleMovie}/>
    <Route exact path="/movie" component={Movies}/>
    
    </Switch> 
  </>
  );
};
export default App;
